export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('drag-scroll', {
    mounted(el) {
      let isDown = false
      let startX: number
      let scrollLeft: number

      el.style.cursor = 'grab'
      el.classList.add('hide-scrollbar')

      el.addEventListener('mousedown', (event: MouseEvent) => {
        isDown = true
        el.style.cursor = 'grabbing'
        startX = event.pageX - el.offsetLeft
        scrollLeft = el.scrollLeft
      })

      el.addEventListener('mouseup', () => {
        isDown = false
        el.style.cursor = 'grab'
      })

      el.addEventListener('mouseleave', () => {
        isDown = false
        el.style.cursor = 'grab'
      })

      el.addEventListener('mousemove', (event: MouseEvent) => {
        if (!isDown) return
        event.preventDefault()
        const x = event.pageX - el.offsetLeft
        const walk = x - startX
        el.scrollLeft = scrollLeft - walk
      })

      el.addEventListener('wheel', (event: WheelEvent) => {
        event.preventDefault()
        el.scrollLeft += event.deltaX
      })
    },
  })
})
